import React from 'react';
import { LayoutDashboard, Users, Calendar, BarChart3, TrendingUp, Settings, Target, CheckSquare } from 'lucide-react';
interface SidebarProps {
  currentPage?: string;
  onNavigate?: (page: string) => void;
}
const navItems = [{
  icon: LayoutDashboard,
  label: 'Home',
  page: 'home'
}, {
  icon: Users,
  label: 'Kontakte',
  page: 'contacts'
}, {
  icon: Target,
  label: 'Sales Board',
  page: 'board'
}, {
  icon: BarChart3,
  label: 'KPI Tracker',
  page: 'kpi'
}, {
  icon: CheckSquare,
  label: 'LinkedIn Routine',
  page: 'linkedin'
}, {
  icon: Calendar,
  label: 'Kalender',
  page: 'calendar'
}, {
  icon: Settings,
  label: 'Einstellungen',
  page: 'settings'
}];
export function Sidebar({
  currentPage = 'contacts',
  onNavigate
}: SidebarProps) {
  return <aside className="w-16 border-r border-border bg-card flex flex-col items-center py-4" data-id="element-99">
      <div className="mb-8" data-id="element-100">
        <button onClick={() => onNavigate?.('home')} className="h-10 w-10 rounded-lg flex items-center justify-center hover:bg-accent transition-colors cursor-pointer" title="Home" data-id="element-101">
          <img src="https://cdn.prod.website-files.com/659c06d086ec4cc1e21fb104/659c06d086ec4cc1e21fb113_Dennis-jedlicka-logo_dj-light.svg" alt="Logo" className="h-8 w-8" data-id="element-102" />
        </button>
      </div>

      <nav className="flex-1 flex flex-col items-center gap-2" data-id="element-103">
        {navItems.map(item => <button key={item.label} onClick={() => onNavigate?.(item.page)} className={`h-10 w-10 rounded-lg flex items-center justify-center transition-colors ${currentPage === item.page ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'}`} title={item.label} data-id="element-104">
            <item.icon className="h-5 w-5" data-id="element-105" />
          </button>)}
      </nav>
    </aside>;
}